module.exports = __webpack_public_path__ + "static/media/r49.e130465d.jpg";